import {computed, ComputedRef} from "vue"
import store from "@/vue/planning/store/store"
import screenType from "@/vue/planning/computed/screenType"
// import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"
// import availableNonTransportPackageCodes from "@/vue/planning/computed/availableNonTransportPackageCodes"
// import packDisplayConfig from "@/config/packDisplayConfig"
// import availableFlightPackCodes from "./availableFlightPackCodes"
// import getSiteFromDomain from "../logic/getSiteFromDomain"
// import flightPackCode from "@/config/flightPackCode"
// import trainPackCode from "@/config/trainPackCode"
import { Transport } from "@/types"

interface Package {
    codePackage: string;
    packageId: string;
    name?: string;
    maxPromo?: number;
}

const packagesToDisplay: ComputedRef<Array<Package>> = computed(() => {
    // For mobile we need all packages
    // if (screenType.value === "mobile") return store.getters.availablePackCodes;
    // // Strange behaviour because of store.getters.transport / setter transport
    // if (getSiteFromDomain(window.location.hostname) !== "www.uk.travelski.com" && store.getters.transport) return availableTransportPackCodes.value;
    // if(store.state.transportationSelected) return availableFlightPackCodes.value;
    // if(store.state.season == 'E') {
    //     store.state.packCode = "HS"
    //     return availableNonTransportPackageCodes.value.filter(pack => 
    //         pack.codePackage === "HS" || pack.codePackage === "PMA"
    //     );
    // }
    // Sort packages according to display order
    // const packagesArray = [...availableNonTransportPackageCodes.value];
        
    // const sortedPackages = packagesArray.sort((a, b) => {
    //     const aIndex = packDisplayConfig.indexOf(a.codePackage);
    //     const bIndex = packDisplayConfig.indexOf(b.codePackage);
    //     return aIndex - bIndex;
    // });
    // return sortedPackages;

    if (screenType.value === "mobile") return store.getters.availablePackCodes;

    if (store.getters.transportv2 === Transport.FLIGHT)
         return store.getters.availableFlightPackCodes;
    else if (store.getters.transportv2 === Transport.TRAIN)
         return store.getters.availableTrainPackCodes;
    
    if(store.state.season == 'E') {
        store.state.packCode = "HS"
        return store.getters.availableNonTransportPackCodes.filter((pack: { codePackage: string }) => 
            pack.codePackage === "HS" || pack.codePackage === "PMA"
        );
    }
    
    return store.getters.availableNonTransportPackCodes;
})

export default packagesToDisplay